const state = {
  // 基本数据
  baseData: {
    advertiser_id: "",
    advertiserName: "",
    projectId: null,
  },

  //选择的app
  checkedApp: {},
  /*********************  接口数据  **********************/
  //分配规则
  splitRule: {
    budget_and_bid: "adset",
    creative_groups: "adset",
    title_group: "adset",
    projectNum: 1,
  },
  //项目
  deliverySetting: null,
  // 投放内容
  optimizeGoal: null,
  // 原生锚点
  anchorMaterial: null,
  // 推广身份
  nativeSetting: null,
  originNativeSettingData: {
    identityType: "TIKTOK",
    anchor_related_type: "OFF",
  },
  // 产品信息
  productInfo: null,
  // 关联产品投放
  relatedProduct: null,
  // 投放位置
  deliveryRange: null,
  //人群包
  audiences: null,
  // 当前选择的人群包
  currentSelectedAudience: null,
  // 落地页
  sitePage: null,
  //定向包
  targeting: null,
  // 当前定向包的id
  currentSelectedTargetingId: null,
  // 当前定向包
  currentSelectedTargeting: null,
  //预算与报价
  budgetBids: null,
  //创意组
  creative_groups: null,
  //标题组
  title_group: null,
  //其他配置
  trackUrlSetting: null,
};

const actions = {};

const mutations = {
  //设置账号数据
  setadCount_ttV2(state, data) {
    state.baseData.advertiser_id = data.advertiser_id;
    state.baseData.advertiserName = data.advertiserName;
  },
  //设置产品app数据
  setcheckedApp_ttV2(state, data) {
    state.checkedApp = data;
  },
  // 设置已有项目ID
  set_already_projectID: (state, data) => {
    state.baseData.projectId = data;
  },

  //设置分配规则
  set_split_rule_ttV2: (state, data) => {
    state.splitRule[data.key] = data.value;
  },
  //批量设置分配规则
  set_all_split_rule_ttV2: (state, data) => {
    state.splitRule = data;
  },
  //设置项目
  set_project_delivery_setting: (state, data) => {
    state.deliverySetting = data;
  },
  //设置基础设置-投放内容
  set_optimize_goal_ttV2: (state, data) => {
    state.optimizeGoal = data;
  },
  //设置基础设置-原生锚点
  set_anchor_material_ttV2: (state, data) => {
    state.anchorMaterial = data;
  },
  //设置基础设置-推广身份
  set_native_setting_ttV2: (state, data) => {
    state.nativeSetting = data;
  },
  //设置基础设置-推广身份,原生锚点（用于回显）
  set_origin_native_data_ttV2: (state, data) => {
    state.originNativeSettingData = { ...data };
  },
  //设置基础设置-产品信息
  set_product_info_ttV2: (state, data) => {
    state.productInfo = data;
  },
  //设置基础设置-关联产品投放
  set_related_product_ttV2: (state, data) => {
    state.relatedProduct = data;
  },
  //设置基础设置-投放位置
  set_deliveryRange_ttV2: (state, data) => {
    state.deliveryRange = data;
  },
  //设置基础设置-人群包
  set_audience_ttV2: (state, data) => {
    state.audiences = data;
  },
  //设置基础设置-落地页
  set_sitePage_ttV2: (state, data) => {
    state.sitePage = data;
  },
  //设置当前选中的人群包
  set_current_selected_audience_ttv2: (state, data) => {
    state.currentSelectedAudience = data;
  },
  //设置定向包
  set_targeting_ttV2: (state, data) => {
    state.targeting = data;
  },
  //设置当前选中定向包ID
  set_current_selected_targeting_id_ttV2: (state, data) => {
    state.currentSelectedTargetingId = data;
  },
  //设置当前选中定向包数据
  set_current_selected_targeting_ttV2: (state, data) => {
    state.currentSelectedTargeting = data;
  },
  //设置预算和出价
  set_budget_and_bid_ttV2: (state, data) => {
    state.budgetBids = data;
  },
  //广告创意-创意组
  set_creative_groups_ttV2: (state, data) => {
    state.creative_groups = data;
  },
  set_creative_groupName_ttV2: (state, data) => {
    //修改创意组名称
    let { name, id } = data;
    let curGroup = state.creative_groups.find((item) => item.itemId === id);
    if (curGroup) {
      curGroup.group_name = name;
    }
  },
  //广告创意-标题
  set_title_group_ttV2: (state, data) => {
    state.title_group = data;
  },
  //设置其他配置
  set_trackUrl_setting_ttV2: (state, data) => {
    state.trackUrlSetting = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
